import { Route, Routes } from 'react-router-dom';
import AgrementPage from '../pages/Login/AgrementPage';
import BasicInfoPage from '../pages/Login/BasicInfoPage';
import ForgotPasswordPage from '../pages/Login/ForgotPasswordPage';
import LoginMainPage from '../pages/Login/LoginMainPage';
import ResetPasswordPage from '../pages/Login/ResetPasswordPage';
import SignUpPage from '../pages/Login/SignUpPage';
import BasicInfoForDBLifePage from '../pages/DBInsurance/BasicInfoForDBLifePage';
import SleepingJellyLoginPage from '../pages/Login/SleepingJellyLoginPage';

export default function te() {
  return (
    <div className="no-scrollbar min-h-full h-full min-h-screen w-full overflow-y-auto bg-[#1a1a22]">
      <Routes>
        <Route path="/" element={<LoginMainPage />} />
        <Route path="signWithEmail" element={<SignUpPage />} />
        <Route path="forgotPassword" element={<ForgotPasswordPage />} />
        <Route path="agrement" element={<AgrementPage />} />
        <Route path="basicInfo" element={<BasicInfoPage />} />
        <Route path="basicInfo-db" element={<BasicInfoForDBLifePage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route path="login/jelly" element={<SleepingJellyLoginPage />} />
      </Routes>
    </div>
  );
}
